export const hourAdjust = (hours: number): number => (hours === 0 ? 12 : hours > 12 ? hours - 12 : hours);
export const dayPart = (hours: number): string => (hours < 12 ? 'AM' : 'PM');
